import { DocsAudit, DocsAuditReservedResourceIdType } from "./RefAudit.dto";
import { LoLang } from "../common/common.types";
import { RefResourceType } from "../ref/Ref.dto";
import { RefAuditAction, RefAuditCategory } from "../ref/RefAudit.dto";

export function readableDocsAuditResourceType(audit: DocsAudit): string {
  switch (audit.type) {
    case RefResourceType.Docs_FolderSharing:
    case RefResourceType.Docs_FolderSharingIpWhitelist:
    case RefResourceType.Docs_FolderSharingLink:
    case RefResourceType.Docs_FolderSharingSetting:
      return audit.reserved2 === DocsAuditReservedResourceIdType.FolderFile ? "File" : "Folder";
    case RefResourceType.Docs_Folder:
    case RefResourceType.Docs_FolderVariable:
      return "Folder";
    case RefResourceType.Docs_FolderFile:
      return "File";
    case RefResourceType.Docs_Document:
      return "Document";
    case RefResourceType.Docs_DocumentSign:
      return "Document Sign";
    case RefResourceType.Docs_DocumentSigner:
    case RefResourceType.Docs_DocumentSignerAttr:
      return "Document Signer";
    case RefResourceType.Docs_Proposal:
    case RefResourceType.Docs_ProposalComment:
    case RefResourceType.Docs_ProposalContent:
    case RefResourceType.Docs_ProposalSection:
    case RefResourceType.Docs_ProposalTitle:
    case RefResourceType.Docs_ProposalVersion:
      return "Proposal";
    case RefResourceType.Docs_Sign:
    case RefResourceType.Docs_SignAttr:
    case RefResourceType.Docs_SignToken:
      return "Sign";
    case RefResourceType.Docs_Signer:
      return "Signer";
    case RefResourceType.Docs_EconsentHistory:
      return "Econsent History";
    case RefResourceType.Docs_FileExportHistory:
      return "File Export History";
    case RefResourceType.Docs_DocumentSignSchedule:
      return "Document Sign Schedule";
    default:
      return "(Unknown)";
  }
}

export function readableDocsAuditResourceName(audit: DocsAudit, resourceName: string): string {
  const resourceType = audit.reserved2 === DocsAuditReservedResourceIdType.FolderFile ? "File" : "Folder";

  switch (audit.type) {
    case RefResourceType.Docs_Folder:
      if (audit.category === RefAuditCategory.Docs_Folder_Signer_Download) {
        return "Signers Download";
      }
      return resourceName;

    case RefResourceType.Docs_FolderFile:
    case RefResourceType.Docs_Proposal:
    case RefResourceType.Docs_Document:
    case RefResourceType.Docs_Sign:
    case RefResourceType.Docs_DocumentSign:
    case RefResourceType.Docs_DocumentSigner:
    case RefResourceType.Docs_Signer:
      return resourceName;
    case RefResourceType.Docs_EconsentHistory:
    case RefResourceType.Docs_FileExportHistory:
      return "-";
    case RefResourceType.Docs_FolderSharing:
      return `${resourceType} Sharing`;
    case RefResourceType.Docs_FolderSharingIpWhitelist:
      return `${resourceType} Sharing Ip White List`;
    case RefResourceType.Docs_FolderSharingLink:
      return `${resourceType} Sharing Link`;
    case RefResourceType.Docs_FolderSharingSetting:
      return `${resourceType} Sharing Setting`;
    case RefResourceType.Docs_FolderVariable:
      return `${resourceType} Variable`;
    case RefResourceType.Docs_ProposalVersion:
      return "Proposal Version";

    default:
      return "(Unknown)";
  }
}

export function readableDocsAuditAction(audit: DocsAudit, lang?: LoLang | undefined, isDestroyed?: boolean): string {
  if (isDestroyed) {
    return lang === "KO" ? "삭제" : "Delete";
  }

  switch (audit.action) {
    case RefAuditAction.Create:
      return lang === "KO" ? "생성" : "Create";
    case RefAuditAction.Update:
      return lang === "KO" ? "수정" : "Update";
    case RefAuditAction.Delete:
      return lang === "KO" ? "삭제" : "Delete";
    case RefAuditAction.Read:
      return [RefAuditCategory.Docs_FolderFile_Download, RefAuditCategory.Docs_Folder_Signer_Download].includes(audit.category)
        ? lang === "KO"
          ? "다운로드"
          : "Download"
        : lang === "KO"
        ? "조회"
        : "Read";
    default:
      return "-";
  }
}
